<template>

  <InfoCodiciConto />
 
</template>

<script>
import InfoCodiciConto from '../components/pratiche/InfoCodiciConto.vue'

export default {
  components: {
    InfoCodiciConto
  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>

